import React from 'react';
import './logout.css';

export default function Logoutpage() {
  return (
    <section className="login-form-section">
      <h2>You are now logged out</h2>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/auth/logout/logoutpage.js